import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useSettings } from '../../context/SettingsContext';

const { FiMapPin, FiPhone, FiMail } = FiIcons;

const Footer = () => {
  const { settings } = useSettings();
  return (
    <footer className="pt-16 pb-8" style={{ backgroundColor: 'var(--brand-footer-bg, #111827)', color: 'var(--brand-footer-text, #ffffff)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Address Details */}
          <div>
            <h3 className="text-xl font-bold mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center p-1">
                <img src={settings.app_logo_url} alt="Logo" className="w-full h-full object-contain" />
              </div>
              {settings.footer_org_name}
            </h3>
            <p className="text-gray-400 mb-6 max-w-sm">
              {settings.footer_tagline}
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-gray-300">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 mt-1 flex-shrink-0" style={{ color: 'var(--brand-accent)' }} />
                <span>{settings.footer_address}</span>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <a 
                href={`tel:${(settings.footer_phone || '').replace(/\s/g, '')}`}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiPhone} className="w-5 h-5" style={{ color: 'var(--brand-accent)' }} />
                {settings.footer_phone}
              </a>
              <a 
                href={`mailto:${settings.footer_email}`}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" style={{ color: 'var(--brand-accent)' }} />
                {settings.footer_email}
              </a>
            </div>
          </div>

          {/* Static Map */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Find Us</h3>
            <a 
              href={settings.footer_map_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-xl overflow-hidden h-48 bg-gray-800 relative group cursor-pointer"
            >
              <img 
                src={settings.footer_map_img}
                alt="Map location" 
                className="w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-opacity duration-300" 
              />
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="p-2 rounded-full shadow-lg" style={{ backgroundColor: 'var(--brand-primary)' }}>
                  <SafeIcon icon={FiMapPin} className="w-6 h-6 text-white" />
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} {settings.footer_org_name}. All rights reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;